import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Info = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > .icon {
    color: ${theme.palette.secondary.main};
    width: 40px;
    height: 40px;
    margin-right: 16px;
  }

  > .info {
    line-height: 1.3;

    .name {
      font-weight: 700;
      font-size: 14px;
      color: ${theme.palette.text.dark};
    }

    .email {
      font-weight: 400;
      font-size: 13px;
      color: ${theme.palette.secondary.main};
    }
  }
`;

export const Role = styled('div')`
  display: inline-flex;
  background: ${theme.palette.background.gray};
  color: ${theme.palette.text.dark};
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 700;
  line-height: 125%;

  &.green {
    background: ${theme.palette.green.light};
    color: ${theme.palette.green.main};
  }
`;

export const Actions = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;
